module.exports = __webpack_public_path__ + "static/drow-264538e203edb3e6e79fc706562c3b63.jpg";